import { useResponsive } from "@design-lab/shared/hooks/useResponsive";
import { TabCard } from "@design-lab/shared/ui/layouts/TabCard";
import { useEnhancementsStarted } from "../model/useEnhancementsStarted";
import { DesignLabImageSelector } from "./DesignLabImageSelector";

type UploadArtworkProps = {
  side?: "front" | "back";
};

export function UploadArtwork({ side }: UploadArtworkProps = {}) {
  const { isDesktop } = useResponsive();

  // Handle enhancements_started flow
  useEnhancementsStarted();

  // If side prop is provided, only show that side (used within FrontBackSubTabs)
  if (side) {
    return (
      <TabCard showNextButton={!isDesktop}>
        <DesignLabImageSelector side={side} />
      </TabCard>
    );
  }

  // Fallback: show front side
  return (
    <TabCard title="1. Upload" hideFooter showNextButton={!isDesktop}>
      <DesignLabImageSelector side={"front"} />
    </TabCard>
  );
}
